var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Podcasts grid"},[_c('h1',[_vm._v(_vm._s(_vm.text))]),_c('div',{staticClass:"grid-auto-md"},_vm._l((_vm.page.podcasts),function(podcast){return _c('AboutThumb',{key:podcast.url,attrs:{"item":podcast}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }